import React from "react";

function InventoryCommandField({value, onChange}) {

    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <div className="network-scan-control-v2">
                <label className="network-scan-control-label-v2" htmlFor="inventoryCommand">Add Subnet</label>
                <input className="network-scan-input-v2"
                  id="inventoryCommand"
                  type="text"
                  value={value}
                  onChange={event => handleChange(event.target.value)} />
        </div>
    );
}


export default InventoryCommandField;
